<template
  ><div>
    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on }">
        <v-btn fab small outline v-on="on" class="ml-1 extra-small" color="primary">
          <span class="fas fa-ellipsis-v"></span>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-for="(item, index) in payment ? paymentIntent : intents"
          :key="index"
          @click="$emit('addIntentPrefill', item.value)"
        >
          <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="openDialog" v-if="$store.getters.getPackage === 'premium'&&!followUp">
          <v-list-tile-title class="primary-color">{{
            $t('Insert') + $t('data_collection.title')
          }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-dialog persistent v-model="dialog" width="500">
      <v-card class="pa-2">
        <v-layout>
          <v-flex>
            <h3 class="primary--text pa-2">
              {{ $t('Setting') + $t('data_collection.title') }}
              <a href="https://blog.zwiz.app/เก็บข้อมูลลูกค้าbot-survey/" target="blank">
                <i class="fas fa-question-circle" style="font-size: 18px; color: rgb(237, 30, 121);"></i>
              </a>
            </h3>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <div class="form-control">
          <v-layout>
            <v-flex class="pa-2">
              <div class="form-control" :class="{ 'has-error': errors.has('dataNameInput') }">
                <label>{{ $t('data_collection.name') }}</label>
                <input
                  type="text"
                  class="form-control"
                  name="dataNameInput"
                  :data-vv-as="$t('data_collection.name')"
                  v-model="insertName"
                  v-validate="'required'"
                />
                <span class="text-error" v-show="errors.has('dataNameInput')">
                  {{ errors.first('dataNameInput') }}
                </span>
            </div>
            </v-flex>
            <v-flex class="pa-2">
              <div class="form-control" :class="{ 'has-error': errors.has('dataValueInput') }">
                <label>{{ $t('data_collection.value') }}</label>
                <input
                  type="text"
                  class="form-control"
                  name="dataValueInput"
                  placeholder="{msg}"
                  :data-vv-as="$t('data_collection.value')"
                  v-model="insertAnswer"
                  v-validate="'required'"
                />
                <span class="text-error" v-show="errors.has('dataValueInput')">
                  {{ errors.first('dataValueInput') }}
                </span>
            </div>
            </v-flex>
            <v-menu offset-y open-on-hover>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  small
                  outline
                  v-on="on"
                  style="top: 30px;"
                  class="ml-1 extra-small"
                  color="primary"
                >
                  <span class="fas fa-ellipsis-v"></span>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in payment ? paymentIntent : intents"
                  :key="index"
                  @click="addAnswer(item.value)"
                >
                  <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </div>
        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="addIntent">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['payment', 'followUp', 'isIntent', 'isWelcome'],
  data: function() {
    return {
      dialog: false,
      isShow: true,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      search: '',
      insertName: '',
      insertAnswer: '{msg}',
      intents: [
        {
          name: this.$t('Insert') + this.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('last name'),
          value: 'last_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Status'),
          value: 'status',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Tag'),
          value: 'tags',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Message'),
          value: 'msg',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Post link url'),
          value: 'post_link_url',
          description: ''
        }
      ]
    }
  },
  mounted: function() {
    var vm = this
    if (vm.isIntent || vm.isWelcome) {
      vm.intents = [
        {
          name: this.$t('Insert') + this.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('last name'),
          value: 'last_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Status'),
          value: 'status',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Tag'),
          value: 'tags',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Message'),
          value: 'msg',
          description: ''
        }
      ]
    }
    if (vm.followUp) {
      vm.intents = [
        {
          name: vm.$t('Insert') + vm.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: vm.$t('Insert') + vm.$t('last name'),
          value: 'last_name',
          description: ''
        },
        {
          name: vm.$t('Insert') + vm.$t('Status'),
          value: 'status',
          description: ''
        },
        {
          name: vm.$t('Insert') + vm.$t('Tag'),
          value: 'tags',
          description: ''
        }
      ]
    }
    if (vm.$store.getters.getPackage !== 'premium') {
      vm.intents = [
        {
          name: this.$t('Insert') + this.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('last name'),
          value: 'last_name',
          description: ''
        }
      ]
    }
    // document.addEventListener('click', this.documentClick)
  },
  computed: {
    paymentIntent() {
      return [this.intents[0], this.intents[1]]
    },
    filterIntents: function() {
      var vm = this
      return vm.intents.filter(intent => {
        return intent.name.toLowerCase().includes(vm.search.toLowerCase())
      })
    }
  },
  methods: {
    async addIntent() {
      const result = await this.$validator.validateAll()

      if (!result) {
        this.goToErrorInput()
        return false
      }

      const session = `save session.${this.insertName} = ${this.insertAnswer}`
      this.$emit('addIntentPrefill', session)
      this.dialog = false
    },
    addAnswer(value) {
      this.insertAnswer = this.insertAnswer + `{${value}}`
    },
    openDialog() {
      this.insertName = ''
      this.insertAnswer = '{msg}'
      this.dialog = true
    }
  },
  destroyed() {
    // important to clean up!!
    // document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style scoped>
.z-dropdown .dropdown-content {
  transform-origin: 0px 0px;
  opacity: 1;
  transform: scaleX(1) scaleY(1);
}
.z-dropdown a {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefill.vue